import { render } from "./IndicatorPoint.vue?vue&type=template&id=01ee85da&scoped=true"
const script = {}

import "./IndicatorPoint.vue?vue&type=style&index=0&id=01ee85da&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ee85da"]])

export default __exports__